import { toast } from "react-toastify";
import { BASE_URL, InwardhideColumn } from "../../global";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import { fetchObservationTypeByTestIds } from "./fetchHandler";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import moment from "moment";
import { generateNumber } from "../../utils/utils";


const resolveReportNumber = (settingList, seq, selectedDiscipline, locationType, inwardData, jobNumber = "") => {
  const reportNoSetting = settingList?.find(s => s.keyName === "reportNo");

  if (!reportNoSetting?.value) {
    return `Report/${seq}`;
  }

  const locationMap = { 1: "Lab", 2: "Site", 3: "Mobile" };

  const props = {
    entryDate:  inwardData?.entryDate || new Date(),
    discipline: selectedDiscipline || "",
    location:   locationMap[locationType] || "Lab",
    jobNo: jobNumber,
  };
  // Replace {location} before passing to generateNumber (it doesn't know this token)
  const template = reportNoSetting.value
    .replace("{location}", props.location)
    .replace("{no}", seq)
    .replace("{jobNo}", props.jobNo);

  return generateNumber(template, seq, props);
};

// 🔹 Child Table Save/Update Function (Add + Update only, no Delete)
export const saveInwardTestRows = async (inwardId, inwardTestRows, isNew, deletedIds, inwardData, settingList) => {
  try {

    let labrefNo = inwardData?.labReferenceNo?.split("-")?.pop() || "";
    const selectedDiscipline = DisciplineOptions.find((d) => d.id == inwardData?.disciplineId)?.label;
    const locationType = Number(inwardData?.location);
    // Fetch jobNo ONCE before formattedRows
    let jobNumber = "";
    if (settingList?.find(s => s.keyName === "reportNo")?.value?.includes("{jobNo}") && inwardData?.jobId) {
      try {
        const res = await axiosWithToken.get(`${BASE_URL}jobRegister/${inwardData.jobId}`);
        jobNumber = res.data?.[0]?.jobNumber || "";
      } catch (e) {
        console.error("Failed to fetch jobNo:", e);
      }
    }

    if (!inwardTestRows || inwardTestRows.length === 0) return;
    // Format rows
       // Collect ALL unique testIds across all rows
    const allTestIds = [];
    inwardTestRows.forEach(row => {
      const ids = row.testId
        ? (Array.isArray(row.testId)
            ? row.testId
            : String(row.testId).split(",").map(Number))
        : [];
      ids.forEach(id => {
        if (!allTestIds.includes(id)) allTestIds.push(id);
      });
    });
    // Fetch observationType for all testIds from DB in one call
    const observationTypeFromDB = allTestIds.length > 0 ? await fetchObservationTypeByTestIds(allTestIds) : {};
    const allCombineTestIds = [];

    const formattedRows = inwardTestRows.map(({ isLocal, observationTypeMap, ...row }, idx) => {
      const seq = idx + 1;

      const testIds = row.testId
        ? (Array.isArray(row.testId)
            ? row.testId
            : String(row.testId).split(",").map(Number))
        : [];

      // Use observationTypeMap if available (new rows), else fall back to DB fetch (existing rows)
      const resolvedMap = (observationTypeMap && Object.keys(observationTypeMap).length > 0)
        ? observationTypeMap
        : observationTypeFromDB;

      const observationTypes = testIds
        .map(id => resolvedMap?.[id] ?? "")
        .join(",");

      // Collect combineTestIds (observationType == 2)
      testIds.forEach(id => {
        if (resolvedMap?.[id] == 2 && !allCombineTestIds.includes(id)) {
          allCombineTestIds.push(id);
        }
      });

      return {
        ...row,
        inwardId,
        testId: Array.isArray(row?.testId) ? row.testId.join(",") : row?.testId || null,
        ulrNumber: `TC125772500000000${seq}`,
        reportNumber: resolveReportNumber(settingList, seq, selectedDiscipline, locationType, inwardData, jobNumber),
        testNumber: `${labrefNo}/${seq}`,
      };
    });

    // schema
    const schema = {
      observationSheet: [
        "inwardTestId", "testId", "boreHoleNo", "testNumber", "reportNumber", "ulrNumber", "inwardId"
      ],
      certificate: [
        "reportNumber", "ulrNumber", "inwardId"
      ],
    };
    const ignoreKeys = ["testNumber", "reportNumber", "ulrNumber" ];
    const combineTestId = locationType == 2 ? null : allCombineTestIds.length > 0 ? allCombineTestIds.join(",") : undefined;

    // Create Mode → only POST
    if (isNew) {
      // testingInward payload when creating new inward
      const payload = {
        inwardTestsRows: formattedRows,
        schema,
        ignoreKeys,
       ...(combineTestId !== undefined && { combineTestId }),
        locationType,    
      };
      await axiosWithToken.post(BASE_URL + `testingInward`, payload);
      return;
    } else {
    
      const patchPayload = {
        inwardTestsRows: formattedRows,
        schema,
        ignoreKeys,
        ...(combineTestId !== undefined && { combineTestId }),
        locationType,
      };

      await axiosWithToken.patch(BASE_URL + "testingInward", patchPayload);
    
  }
  } catch (error) {
    console.error("Error saving inward test rows:", error);
    throw error;
  }
};

// 🔹 Main Parent Function
export const handleInwardSubmit = async (
  params,
  inputStates,
  officeFormData,
  inwardTestRows,
  deletedIds,
  settingList,
  csrfFormPayload,
  CSRFFetchData,
  navigate
) => {
  // Step 1: Validate main form fields
  const fieldsToValidate = [
    { value: inputStates.location, label: "Select Location" },
    { value: inputStates.jobId, label: "Job selection Required" },
    { value: inputStates.inwardDate, label: "Inward Date Required" },
  ];
  if (!validateRequiredFields(fieldsToValidate)) {
    return;
  }
 // Step 2: Check if test rows are added
  if (!inwardTestRows || inwardTestRows.length === 0) {
    toast.error("Add Test");
    return;
  }
  // Step 3: Validate each inwardTestRow
  for (let i = 0; i < inwardTestRows.length; i++) {
    const row = inwardTestRows[i];
    const rowNumber = i + 1;
    
    if(inputStates.location != 2){
      if (!InwardhideColumn.includes("boreHoleNo") && !row.boreHoleNo?.trim()) {
        toast.error(`Row ${rowNumber}: BH No. / Trial Pit No. is required.`);
        return;
      }
  
      if (!InwardhideColumn.includes("locationChainageNo") && !row.locationChainageNo?.trim()) {
        toast.error(`Row ${rowNumber}: Location/Chainage No./Source. is required.`);
        return;
      }
  
      if (!InwardhideColumn.includes("fromDepth") && !row.fromDepth?.toString().trim()) {
        toast.error(`Row ${rowNumber}: From Depth is required.`);
        return;
      }

      if (!InwardhideColumn.includes("groupId") && !row.groupId) {
        toast.error(`Row ${rowNumber}: Group is required.`);
        return;
      }
  
      if (!InwardhideColumn.includes("materialId") && !row.materialId) {
        toast.error(`Row ${rowNumber}: Material is required.`);
        return;
      }
    }

    if (!row.testId) {
      toast.error(`Row ${rowNumber}: Test is required.`);
      return;
    }
  }
  try {
    let inwardId = params.id;
    const { jobDate, ...sanitizedPayload } = inputStates;

    // Step 1: Save inward table
    const inwardPayload = {
      ...sanitizedPayload,
      createdBy: localStorage.getItem("id"),
    };
    const inwardUrl = BASE_URL + `inward`;
    let inwardData = null;

    if (params.id == 0) {
      const res = await axiosWithToken.post(inwardUrl, inwardPayload);
      inwardId = res?.data?.insertId;

      // 🔹 Fetch the newly created inward to get labReferenceNo generated by trigger
      const fetchRes = await axiosWithToken.get(`${inwardUrl}/${inwardId}`);
      inwardData = fetchRes?.data?.[0] || {};

    } else {
      await axiosWithToken.patch(inwardUrl + `/${inwardId}`, inwardPayload);

       // Use local labReferenceNo if available, else fetch it
       if (inputStates.labReferenceNo) {
        inwardData = { ...inwardPayload, labReferenceNo: inputStates.labReferenceNo };
      }
    }

    // Step 2: Save inward_officeReview table
    const officePayload = {
      ...officeFormData,
      inwardId: inwardId,
      retentionFrequency: officeFormData.retentionperiod === "Yes" ? officeFormData.retentionFrequency : null,
    };

    const officeUrl = BASE_URL + `inward_officeReview`;

    if (params.id == 0) {
      await axiosWithToken.post(officeUrl, officePayload);
    } else {
      await axiosWithToken.patch(officeUrl + `/${inwardId}`, officePayload);
    }

    // Step 3: Save CSRF form
    await saveCSRFForm(inwardId, csrfFormPayload, CSRFFetchData, params.id == 0);

    // Step 4: Save child rows (only add/update, no delete)
    await saveInwardTestRows(inwardId, inwardTestRows, params.id == 0, deletedIds, inwardData, settingList);

    toast.success(params.id != 0 ? "Inward Updated!" : "Inward Created!");

    if (params.id == 0) {
      setTimeout(() => navigate("/inwardList"), 1000);
    } else {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error saving inward data:", error);
  }
};

export const saveCSRFForm = async (inwardId, csrfFormPayload, CSRFFetchData, isNew) => {
  try {
    const payload = { ...csrfFormPayload, inwardId };
    const url = BASE_URL + `csrfForm`;
    if (isNew || !CSRFFetchData?.id) {
      await axiosWithToken.post(url, payload);
    } else {
      await axiosWithToken.patch(url + `/${CSRFFetchData?.id}`, payload);
    }
  } catch (error) {
    console.error("Error saving CSRF form:", error);
    throw error;
  }
};